import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Padlock = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M16.25 9.75v-2.5a4.25 4.25 0 0 0-8.5 0v2.5M12 14v3m-5.25 4.25h10.5a2 2 0 0 0 2-2v-7.5a2 2 0 0 0-2-2H6.75a2 2 0 0 0-2 2v7.5a2 2 0 0 0 2 2'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.25a5 5 0 0 0-5 5V9h-.25A2.75 2.75 0 0 0 4 11.75v7.5A2.75 2.75 0 0 0 6.75 22h10.5A2.75 2.75 0 0 0 20 19.25v-7.5A2.75 2.75 0 0 0 17.25 9H17V7.25a5 5 0 0 0-5-5M15.5 9V7.25a3.5 3.5 0 1 0-7 0V9zM12 13.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75'
        fill='currentColor'
      />
    )}
  </IconBase>
);
